import { render, staticRenderFns } from "./employment_yukon.vue?vue&type=template&id=d4b1dc78&"
import script from "./employment_yukon.vue?vue&type=script&lang=js&"
export * from "./employment_yukon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports